<template>
  <div>
    <transition-group tag="div" class="img-slider" name="slide" style="margin-top: 25px">
      <div v-for="(anObject, i) in objects" :key="`obj-${i}`" >
        <h2> Catch :</h2>
        <b-img
            :src="`/assets/apps/matchgame/${anObject.imgPath}`"
        />
      </div>
    </transition-group>

    <transition-group tag="div" class="img-slider" name="slide"
                      style="margin-top: 25px"
    >
      <div v-for="number in [currentImg]" v-bind:key="number" >
        <b-img
            :src="`/assets/apps/matchgame/${objects[number].imgPath}`"
        />
      </div>
    </transition-group>
  </div>
</template>

<script>

export default {
  name: "Display_MatchGame_GamePlay",
  components: {},
  mounted() {
    setInterval(() => {
      this.currentImg = this.currentImg + 1;
    }, 5000);
  },
  props: {
    objects: {
      type: Array,
      default: () => { return []}
    }
  },
  computed: { },
  methods: {},
  data() {
    return {
      currentImg: 0,
      objectsOld: [
        'http://via.placeholder.com/350x150',
        'http://via.placeholder.com/350x151',
        'http://via.placeholder.com/350x152'
      ],
    }
  }
};
</script>

<style lang="scss" scoped>
#demo {
  overflow: hidden;
}

.slide-leave-active,
.slide-enter-active {
  transition: 1s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(-100%, 0);
}

.img-slider{
  overflow: hidden;
  position: relative;
  height: 200px;
  width: 100%;
}

.img-slider img {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right:0;
}
</style>
